"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoomService = void 0;
const tsyringe_1 = require("tsyringe");
const RPCJSONService_1 = require("../httpService/RPCJSONService");
const proxyWalletService_1 = require("../proxyWalletService/proxyWalletService");
const JSONRPCMethods_enum_1 = require("../../../../models/JSONRPCMethods.enum");
const required_1 = require("../../../../helpers/required/required");
const fetchRoomService_1 = require("../../../utils/services/fetchRoomService/fetchRoomService");
const rightService_1 = require("../../../utils/services/rightService/rightService");
const websocketService_1 = require("../websocketService/websocketService");
const messageService_1 = require("../messageService/messageService");
let RoomService = class RoomService {
    constructor(messagingService, fetchRoomService, rightService, httpService, websocketService, messageService) {
        this.messagingService = messagingService;
        this.fetchRoomService = fetchRoomService;
        this.rightService = rightService;
        this.httpService = httpService;
        this.websocketService = websocketService;
        this.messageService = messageService;
        this.getNFTRoom = this.fetchRoomService.fetchRoom;
    }
    /**
     * Get all messages from roomId and section
     * @param {{roomId: string; sectionId: string}} parameters
     * @returns {Promise<{jsonrpc: number; id: string; result?: any}>}
     */
    getMessages(parameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const { roomId, sectionId } = parameters;
            required_1.requiredDefined(roomId, 'roomId is required');
            required_1.requiredDefined(sectionId, 'sectionId is required');
            const tokenContent = yield this.fetchRoomService.fetchRoom(roomId);
            const { endpoint } = tokenContent;
            const params = {
                sectionId,
                roomId
            };
            return this.httpService.signedRPCCall(endpoint, JSONRPCMethods_enum_1.JSONRPCMethods.room.message.read, params);
        });
    }
    newMessageListener(cb) {
        this.messageService.messageEvent(cb);
    }
    /**
     * Send message to roomId + sectionId
     * @param {{roomId: string; sectionId: string; messageContent: any}} parameters
     * @returns {Promise<{jsonrpc: number; id: string; result?: any}>}
     */
    sendMessage(parameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const { roomId, sectionId, messageContent } = parameters;
            required_1.requiredDefined(roomId, 'roomId is required');
            required_1.requiredDefined(sectionId, 'sectionId is required');
            required_1.requiredDefined(messageContent, 'messageContent is required');
            const tokenContent = yield this.fetchRoomService.fetchRoom(roomId);
            const { endpoint } = tokenContent;
            const params = {
                content: messageContent,
                sectionId,
                roomId
            };
            return this.httpService.signedRPCCall(endpoint, JSONRPCMethods_enum_1.JSONRPCMethods.room.message.write, params);
        });
    }
    /**
     * Check if user can join room depending on main room strategies
     * @param {{roomId: string}} parameters
     * @returns {Promise<StrategiesReturn>}
     */
    canJoin(parameters) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.rightService.canJoinRoom(Object.assign(Object.assign({}, parameters), { address: this.messagingService.authorizedAddresses[0] }));
        });
    }
    /**
     * Can user write message in this room AND section
     * @returns {Promise<StrategiesReturn>}
     * @param parameters
     */
    canWriteSection(parameters) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.rightService.canWriteSection(Object.assign(Object.assign({}, parameters), { address: this.messagingService.authorizedAddresses[0] }));
        });
    }
    /**
     *  Can user read message in this room AND section
     * @returns {Promise<StrategiesReturn>}
     * @param parameters
     */
    canReadSection(parameters) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.rightService.canReadSection(Object.assign(Object.assign({}, parameters), { address: this.messagingService.authorizedAddresses[0] }));
        });
    }
    /**
     * Join section on this room. It will perform a profile update
     * @param {{roomId: string; sectionId: string; profile: UserProfile}} parameters
     * @returns {Promise<{jsonrpc: number; id: string; result?: any}>}
     */
    joinSection(parameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const { roomId, sectionId, profile, dry } = parameters;
            required_1.requiredDefined(roomId, 'roomId is required');
            required_1.requiredDefined(sectionId, 'sectionId is required');
            required_1.requiredDefined(profile, 'profile is required');
            const tokenContent = yield this.fetchRoomService.fetchRoom(roomId);
            const { endpoint } = tokenContent;
            const params = {
                sectionId,
                profile,
                roomId,
                dry
            };
            yield this.updateProfile(parameters);
            return this.httpService.signedRPCCall(endpoint, JSONRPCMethods_enum_1.JSONRPCMethods.room.section.join, params);
        });
    }
    /**
     * Update profile of current user on this room
     * @param {{roomId: string; sectionId: string; profile: UserProfile}} parameters
     * @returns {Promise<{jsonrpc: number; id: string; result?: any}>}
     */
    updateProfile(parameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const { roomId, sectionId, profile, dry } = parameters;
            required_1.requiredDefined(roomId, 'roomId is required');
            required_1.requiredDefined(sectionId, 'sectionId is required');
            required_1.requiredDefined(profile, 'profile is required');
            const tokenContent = yield this.fetchRoomService.fetchRoom(roomId);
            const { endpoint } = tokenContent;
            const params = {
                sectionId,
                profile,
                roomId,
                dry
            };
            return this.httpService.signedRPCCall(endpoint, JSONRPCMethods_enum_1.JSONRPCMethods.room.section.updateProfile, params);
        });
    }
    /**
     * Get list of section's users
     * @param {{roomId: string; sectionId: string}} parameters
     * @returns {Promise<{jsonrpc: number; id: string; result?: any}>}
     */
    getSectionUsers(parameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const { roomId, sectionId } = parameters;
            required_1.requiredDefined(roomId, 'roomId is required');
            required_1.requiredDefined(sectionId, 'sectionId is required');
            const tokenContent = yield this.fetchRoomService.fetchRoom(roomId);
            const { endpoint } = tokenContent;
            const params = {
                sectionId,
                roomId
            };
            return this.httpService.signedRPCCall(endpoint, JSONRPCMethods_enum_1.JSONRPCMethods.room.section.users, params);
        });
    }
    joinNotificationserver(parameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const { roomId, sectionId } = parameters;
            required_1.requiredDefined(roomId, 'roomId is required');
            required_1.requiredDefined(sectionId, 'sectionId is required');
            this.websocketService.joinSection(parameters);
        });
    }
    fullRoomStrategies(parameters) {
        const { roomId } = parameters;
        const address = this.messagingService.authorizedAddresses[0];
        this.rightService.fullRoomStrategies({ roomId, address });
    }
};
RoomService = __decorate([
    tsyringe_1.scoped(tsyringe_1.Lifecycle.ContainerScoped),
    __metadata("design:paramtypes", [proxyWalletService_1.ProxyWalletService,
        fetchRoomService_1.FetchRoomService,
        rightService_1.RightService,
        RPCJSONService_1.RPCJSONService,
        websocketService_1.WebsocketService,
        messageService_1.MessageService])
], RoomService);
exports.RoomService = RoomService;
//# sourceMappingURL=roomService.js.map